import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Icon } from '@openedx/paragon';
import { Login } from '@openedx/paragon/icons';
import PropTypes from 'prop-types';

import messages from './messages';
import { LOGIN_PAGE, SUPPORTED_ICON_CLASSES } from '../data/constants';

const SocialAuthProviders = (props) => {
  const { formatMessage } = useIntl();
  const { referrer, socialAuthProviders } = props;

  function handleSubmit(e) {
    e.preventDefault();

    const url = e.currentTarget.dataset.providerUrl;
    window.location.href = getConfig().LMS_BASE_URL + url;
  }

  const socialAuth = socialAuthProviders.map((provider) => {
    let providerIcon;
    if (provider.iconImage) {
      const iconSrc = /^https?:\/\//.test(provider.iconImage)
        ? provider.iconImage
        : getConfig().LMS_BASE_URL + provider.iconImage;
      providerIcon = <img className="auth-card__sso-img" src={iconSrc} alt="" />;
    } else if (SUPPORTED_ICON_CLASSES.includes(provider.iconClass)) {
      providerIcon = <FontAwesomeIcon icon={['fab', provider.iconClass]} />;
    } else {
      providerIcon = <Icon src={Login} />;
    }

    return (
      <Button
        id={provider.id}
        key={provider.id}
        type="button"
        variant="tertiary"
        className="auth-card__sso-btn"
        data-provider-url={referrer === LOGIN_PAGE ? provider.loginUrl : provider.registerUrl}
        // eslint-disable-next-line react/jsx-no-bind
        onClick={handleSubmit}
      >
        <span className="auth-card__sso-icon" aria-hidden="true">{providerIcon}</span>
        <span id="provider-name" className="notranslate" aria-hidden="true">{provider.name}</span>
        <span className="sr-only">
          {referrer === LOGIN_PAGE
            ? formatMessage(messages['sso.sign.in.with'], { providerName: provider.name })
            : formatMessage(messages['sso.create.account.using'], { providerName: provider.name })}
        </span>
      </Button>
    );
  });

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{socialAuth}</>;
};

SocialAuthProviders.defaultProps = {
  referrer: LOGIN_PAGE,
  socialAuthProviders: [],
};

SocialAuthProviders.propTypes = {
  referrer: PropTypes.string,
  socialAuthProviders: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    iconClass: PropTypes.string,
    iconImage: PropTypes.string,
    loginUrl: PropTypes.string,
    registerUrl: PropTypes.string,
    skipRegistrationForm: PropTypes.bool,
  })),
};

export default SocialAuthProviders;
